import StorytellingHero from "../components/StoryTelling/StoryTellingHero";
//import InViewFade from "../components/Generic/InViewFade";
import StoriesSection from "../components/StoryTelling/StoriesSection";
import StoryTellingCards from "../components/StoryTelling/StoryTellingCards";
import InViewFade from "../components/Generic/InViewFade";

const StroyTelling = () => {
  return (
    <div className="projects-page">
      <InViewFade direction="down"></InViewFade>

      <InViewFade direction="left">
        <StorytellingHero />
      </InViewFade>

      <InViewFade direction="up">
        <StoriesSection />
      </InViewFade>

      <InViewFade direction="right">
        <StoryTellingCards />
      </InViewFade>
    </div>
  );
};

export default StroyTelling;
